import RelationManager from '@/features/relation-manager/RelationManager'
import { collection } from '@/infra/collection'
import DataLoader from 'dataloader'
import type { RelationManagerApi } from '@/features/relation-manager/api/relation-manager-api'
import { NotFound } from 'fejl'
import { mapRelationshipManagerResourceToProps } from '@/features/relation-manager/mappers'
import { Id } from '@/infra/id'
import type { FetchUserFn } from '@/features/iam'
import { isNotNil } from '@/utils/object-util'

export class RelationManagerStore {
  private readonly _loader = new DataLoader(this._fetchManyCore.bind(this))

  constructor(
    private readonly _api: RelationManagerApi,
    private readonly fetchUser: FetchUserFn,
  ) {}

  relationManagers = collection({
    create: () => new RelationManager(),
    getDataId: (d) => d.id,
    getModelId: (m) => m.id,
  })

  async fetch(id: Id) {
    return await this._loader.load(Id.assert(id))
  }

  async _fetchManyCore(jobIds: readonly string[]) {
    const rmResources = await Promise.all(
      jobIds.map(async (id) => {
        const resource = await this._api.get(id).catch(NotFound.ignore(null))

        if (!resource) {
          return null
        }

        return resource.data
      }),
    ).then((r) => r.filter(isNotNil))

    return await Promise.all(
      rmResources.map(async (rm) => {
        const user = await this.fetchUser(rm.userPublicId)
        if (!user) {
          return null
        }

        return { rm, user }
      }),
    )
      .then((r) => r.filter(isNotNil))
      .then((values) => {
        return this.relationManagers.set(
          values.map((values) => mapRelationshipManagerResourceToProps(values)),
        )
      })
  }
}
